import {Emitter} from "./emitter";
import {Cart} from "./cart";

export class rechargeControl extends Emitter {
    constructor(rcContainer, api, bundleGrid) {
        super();
        this.price = 0;
        this.discountedPrice = 0;
        this.api = api;
        this.bundleGrid = bundleGrid;
        this.currentBundleSize = 0;
        this.cartBundle = [];
        this.cart = new Cart(api);
        this.rcContainer = rcContainer;
        this.frequency = rcContainer.find('.v4-rc-frequency');
        // this.handleFrequency = this.handleFrequency.bind(this);
        this.setProductQty = this.setProductQty.bind(this);
        // this.bundleSize = rcContainer.find('.rc-bundle-size');
        // this.handleSize = this.handleSize.bind(this);
        // this.getSize = this.getSize.bind(this);
        // this.setAddToCartButton = this.setAddToCartButton.bind(this);
        this.frequency.on('change', this.handleFrequency);
        // this.bundleSize.on('change', this.handleSize);
    }

    // handleFrequency() {
    //     const { frequency, rcContainer } = this;
    //     let bundleObj = [];
    //     let bundleInCart = false;
    //     this.cart.getData().then((data) => {
    //         for (const lineItem of data.items) {
    //             const {properties} = lineItem;
    //             if (properties.hasOwnProperty('frequency')) {
    //                 if (frequency.val() === properties.frequency) {
    //                     bundleInCart = true;
    //                     bundleObj.push(lineItem);
    //                     this.setProductQty(lineItem.handle, lineItem.quantity);
    //                 }
    //             }
    //         }
    //         if (bundleInCart) {
    //             $(rcContainer).find('.cart-bundle-message').removeClass('d-none');
    //             this.cartBundle = bundleObj;
    //             this.emit('loadedcartbundle', bundleObj);
    //         }
    //     });
    // }

    setProductQty(handle, qty) {
        const bundleGrid = $(this.bundleGrid),
            productTile = bundleGrid.find(`.v4-product-tile[data-product-handle="${handle}"]`);
        productTile.find('.v4-quantity-selector input').val(qty);
    }

    setDiscountedPrice(price) {
        const { rcContainer } = this,
            bundlePriceElement = rcContainer.find('.bundle-price-wrapper .discounted-bundle-price');
        bundlePriceElement.text(price);
        if (price === '$0.00')
            bundlePriceElement.addClass('d-none');
        else
            bundlePriceElement.removeClass('d-none');
    }

    setPrice(price) {
        const {rcContainer} = this,
            bundlePriceElement = rcContainer.find('.bundle-price-wrapper .bundle-price')
        bundlePriceElement.text(price);
        if (price === '$0.00')
            bundlePriceElement.addClass('d-none');
        else
            bundlePriceElement.removeClass('d-none');
    }

    // handleSize(e) {
    //    const addToCartButton = this.rcContainer.find('.add-to-cart'),
    //        size = $(e.target).val(),
    //        currentSize = parseFloat(size) - parseFloat(this.currentBundleSize);
    //     if(currentSize === 0 ) {
    //         addToCartButton.text(`Add To Cart`);
    //         addToCartButton.prop('disabled', false);
    //
    //     } else if(currentSize > 0) {
    //         addToCartButton.text(`Add ${currentSize} to continue`);
    //         addToCartButton.prop('disabled', true);
    //
    //     } else {
    //         addToCartButton.text(`Remove ${Math.abs(currentSize)} to continue`);
    //         addToCartButton.prop('disabled', true);
    //     }
    //    this.emit('sizechange', size);
    //
    // }

    // setAddToCartButton(qty) {
    //     this.currentBundleSize = qty;
    //     const size = this.bundleSize.val(),
    //         addToCartButton = this.rcContainer.find('.add-to-cart'),
    //         currentSize = parseFloat(size) - parseFloat(qty);
    //
    //     if(currentSize === 0) {
    //         addToCartButton.text(`Add To Cart`);
    //         addToCartButton.prop('disabled', false);
    //     }  else if(currentSize > 0) {
    //         addToCartButton.text(`Add ${currentSize} to continue`);
    //         addToCartButton.prop('disabled', true);
    //     } else {
    //         addToCartButton.text(`Remove ${Math.abs(currentSize)} to continue`);
    //         addToCartButton.prop('disabled', true);
    //
    //     }
    // }

}